null


// WEBPACK FOOTER //
// ../Providers/AWSKinesisFirehoseProvider.ts